
import { defineComponent } from 'vue'
import HeaderLogo from './components/HeaderLogo.vue'
export default defineComponent({
  components: {
    'tp-header-logo': HeaderLogo,
  },
  methods: {
    setVariables() {
      let vh = window.innerHeight
      let vw = window.innerWidth
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      document.documentElement.style.setProperty('--vw', `${vw}px`)
    },
  },
  mounted() {
    this.setVariables()
    window.addEventListener('resize', this.setVariables)

    const w = document.querySelector('game__window') || null
   
    if (w) {
      w.addEventListener('touchstart', (e) => {
        e.preventDefault()
      })
    }
  },
})
